import React, { useEffect } from 'react';

import styled from 'styled-components';

import CircularProgress from '@mui/material/CircularProgress';

export default function Loading() {
  const ModalContainer = styled.div`
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: ${({ theme }) => `${theme.colors?.backgroundColor}99`};
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999999;
  `;

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <ModalContainer>
      <CircularProgress />
    </ModalContainer>
  );
}
